import styled from 'styled-components'

import Text from './Text'

const BreakWord = styled(Text)`
  overflow-wrap: break-word;
`

export default BreakWord
